module.exports = __webpack_public_path__ + "img/p2.40d9844d.jpg";